var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._g(
      {
        staticClass: "_field _fldd",
        class: _vm._class,
        style: { width: _vm.width, height: _vm.height },
        attrs: {
          role: "combobox",
          "aria-expanded": _vm.expanded,
          "aria-owns": _vm._id
        }
      },
      _vm.__fwd
    ),
    [
      _vm._l(_vm.selectedOptions, function(o, i) {
        return _vm.multiple
          ? [
              _c(
                "ib-tag",
                {
                  attrs: { deletable: "", disabled: _vm.disabled },
                  on: {
                    delete: function($event) {
                      return _vm._rmtag(o)
                    }
                  }
                },
                [_vm._v(_vm._s(o.textContent))]
              ),
              _vm._v(
                _vm._s(
                  _vm.filtered || i < _vm.selectedOptions.length - 1
                    ? " "
                    : null
                )
              )
            ]
          : _vm._e()
      }),
      _c("span", { staticClass: "_fldi" }, [
        _vm._v("‌"),
        _c(
          "label",
          {
            staticClass: "_fldl",
            class: { _dock: _vm.dock },
            attrs: { for: "_ddi" + _vm._uid }
          },
          [_vm._v(_vm._s(_vm.placeholder))]
        ),
        _vm.filtered
          ? _c(
              "input",
              _vm._g(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter,
                      expression: "filter"
                    }
                  ],
                  ref: "_in",
                  staticClass: "_fldin",
                  attrs: {
                    id: "_ddi" + _vm._uid,
                    name: _vm.name,
                    required: _vm.required,
                    readonly: _vm.readonly,
                    disabled: _vm.disabled,
                    inert: _vm.inert,
                    tabindex: _vm.inert ? -1 : _vm.tabindex,
                    "aria-controls": _vm._id,
                    autocomplete: "new-password",
                    autocorrect: "off",
                    autocapitalize: "off"
                  },
                  domProps: { value: _vm.filter },
                  on: {
                    keydown: _vm._keydown,
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.filter = $event.target.value
                      },
                      _vm.input
                    ]
                  }
                },
                _vm.__on
              )
            )
          : !_vm.native
          ? _c(
              "span",
              _vm._g(
                {
                  ref: "_in",
                  staticClass: "_fldis",
                  class: { _dock: !_vm.dock },
                  attrs: {
                    tabindex:
                      _vm.inert || _vm.disabled ? null : _vm.tabindex || 0
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      !_vm.multiple && _vm.selectedOptions.length
                        ? _vm.selectedOptions[0].innerHTML
                        : _vm.placeholder
                        ? _vm.$string.escapeHTML(_vm.placeholder)
                        : "&zwnj;"
                    )
                  },
                  on: { keydown: _vm._keydown }
                },
                _vm.__on
              )
            )
          : _c(
              "select",
              _vm._g(
                {
                  ref: "_in",
                  staticClass: "_fldin",
                  attrs: {
                    size: "1",
                    id: "_ddi" + _vm._uid,
                    name: _vm.name,
                    multiple: _vm.multiple,
                    required: _vm.required,
                    disabled: _vm.disabled,
                    readonly: _vm.readonly,
                    tabindex: _vm.inert ? -1 : _vm.tabindex
                  },
                  on: { change: _vm._change }
                },
                _vm.__on
              ),
              [
                _vm._l(_vm.data, function(opt) {
                  return [
                    opt.child
                      ? _c(
                          "optgroup",
                          { attrs: { label: opt.label } },
                          _vm._l(opt.child, function(sopt) {
                            return _c(
                              "option",
                              { domProps: { value: _vm.getval(sopt) } },
                              [
                                _vm._t(
                                  "default",
                                  [
                                    _vm._v(
                                      _vm._s(
                                        typeof sopt === "object"
                                          ? sopt.label
                                          : sopt
                                      )
                                    )
                                  ],
                                  null,
                                  sopt
                                )
                              ],
                              2
                            )
                          }),
                          0
                        )
                      : _c(
                          "option",
                          { domProps: { value: _vm.getval(opt) } },
                          [
                            _vm._t(
                              "default",
                              [
                                _vm._v(
                                  _vm._s(
                                    typeof opt === "object" ? opt.label : opt
                                  )
                                )
                              ],
                              null,
                              opt
                            )
                          ],
                          2
                        )
                  ]
                })
              ],
              2
            )
      ]),
      !_vm.native
        ? _c(
            "ul",
            {
              ref: "ul",
              staticClass: "_ddl",
              attrs: { role: "listbox", id: _vm._id }
            },
            [
              _vm._l(_vm.data, function(opt) {
                return [
                  opt.child
                    ? [
                        _c(
                          "li",
                          [
                            _vm._t(
                              "default",
                              [_vm._v(_vm._s(opt.label))],
                              null,
                              opt
                            )
                          ],
                          2
                        ),
                        _vm._l(opt.child, function(sopt) {
                          return _c(
                            "li",
                            {
                              staticClass: "_ind",
                              attrs: {
                                role: "option",
                                "data-value": _vm.getval(sopt)
                              }
                            },
                            [
                              _vm._t(
                                "default",
                                [
                                  _vm._v(
                                    _vm._s(
                                      typeof sopt === "object"
                                        ? sopt.label
                                        : sopt
                                    )
                                  )
                                ],
                                null,
                                sopt
                              )
                            ],
                            2
                          )
                        })
                      ]
                    : [
                        _c(
                          "li",
                          {
                            attrs: {
                              role: "option",
                              "data-value": _vm.getval(opt)
                            }
                          },
                          [
                            _vm._t(
                              "default",
                              [
                                _vm._v(
                                  _vm._s(
                                    typeof opt === "object" ? opt.label : opt
                                  )
                                )
                              ],
                              null,
                              opt
                            )
                          ],
                          2
                        )
                      ]
                ]
              })
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }